import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/images/login/back.png';
import _imports_1 from '@/assets/images/login/close2.png';
import _imports_2 from '@/assets/images/login/logo.png';
const _hoisted_1 = { class: "login_phone flexColumn-alc" };
const _hoisted_2 = { class: "lp_close clickable flexRow-alc flex-jcsb" };
const _hoisted_3 = { class: "flexColumn lp_title" };
const _hoisted_4 = { class: "lpt_welcome" };
const _hoisted_5 = { class: "lp_form flexColumn-alc flex-jcc" };
import { ref } from 'vue';
import config from '@/api/config';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import feedback from '@/utils/feedback';
import request from '@/api/request';
import loginForm from './login_form.vue';
import apiUrl from '@/api/apiUrl';
import { encryptAES } from '@/utils/crypto';
export default /*@__PURE__*/ _defineComponent({
    __name: 'login_register',
    emits: ['close', 'loginSuccess', 'forgetPassword', 'back'],
    setup(__props, { emit: __emit }) {
        const router = useRouter();
        const route = useRoute();
        const store = useStore();
        const emits = __emit;
        const loading = ref(false);
        // 登录
        const submitLogin = async (datas) => {
            loading.value = true;
            try {
                await loginRegister(datas);
            }
            catch (err) { }
            loading.value = false;
        };
        // 验证码登录
        const loginRegister = async (datas) => {
            let res;
            try {
                res = await request.post(apiUrl.register, {
                    mobile: encryptAES(datas.mobile),
                    code: encryptAES(String(datas.code)),
                    password: encryptAES(datas.password),
                });
            }
            catch (error) { }
            // 登录错误
            if ((res === null || res === void 0 ? void 0 : res.code) !== 0)
                return;
            feedback.msgSuccess('注册成功');
            emits('back');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        class: "clickable",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('back')))
                    }, _cache[3] || (_cache[3] = [
                        _createElementVNode("img", {
                            src: _imports_0,
                            style: { "width": "25px", "height": "25px" }
                        }, null, -1)
                    ])),
                    _createElementVNode("div", {
                        class: "clickable",
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('close')))
                    }, _cache[4] || (_cache[4] = [
                        _createElementVNode("img", { src: _imports_1 }, null, -1)
                    ]))
                ]),
                _createElementVNode("aside", _hoisted_3, [
                    _createElementVNode("p", _hoisted_4, "欢迎登录" + _toDisplayString(_unref(config).brand_name), 1),
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flexColumn lpt_nav" }, [
                        _createElementVNode("div", { class: "lptn_item flexRow-alc" }, " 你好，我是你的AI助手 "),
                        _createElementVNode("p", { class: "i_color lptn_tip" }, "生活工作学习，我都能帮你")
                    ], -1)),
                    _cache[6] || (_cache[6] = _createElementVNode("img", {
                        src: _imports_2,
                        class: "lpt_logo"
                    }, null, -1))
                ]),
                _createElementVNode("aside", _hoisted_5, [
                    _createVNode(loginForm, {
                        showModules: ['plioy', 'code', 'password', 'tips'],
                        btnText: "注册",
                        smsType: 4,
                        passwordVerify: "",
                        onForgetPassword: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('forgetPassword'))),
                        onSubmit: submitLogin
                    })
                ])
            ]));
        };
    }
});
